import { proxy } from 'valtio';

const handelswegeTimebarState = proxy({
  areaActive: false,
  splinePoint: 1,
});

export default handelswegeTimebarState;
